"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Decoration = function Decoration(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    "aria-hidden": true,
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    ref: ref
  }, props), (0, _core.jsx)("path", {
    d: "M3.16 27.294l.177.007 11.628.809c1.717.119 3.01 1.632 2.89 3.378-.122 1.747-1.613 3.066-3.33 2.946l-11.628-.808c-1.717-.12-3.01-1.632-2.89-3.379.122-1.746 1.613-3.065 3.33-2.946zm-2-21.9a3.08 3.08 0 014.39-.409l14.856 12.581a3.208 3.208 0 01.401 4.465 3.08 3.08 0 01-4.39.408L1.562 9.858a3.208 3.208 0 01-.4-4.465zM23.997.173c1.626-.563 3.41.322 3.982 1.976l3.636 10.502c.573 1.654-.28 3.452-1.907 4.015-1.627.563-3.41-.321-3.983-1.975L22.09 4.19c-.573-1.655.281-3.452 1.908-4.016z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Decoration);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Decoration, "Decoration", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/Decoration.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/CheeryContainer/Decoration.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();